import { render, staticRenderFns } from "./UsersRolesPermissionsView.vue?vue&type=template&id=30418824&"
import script from "./UsersRolesPermissionsView.vue?vue&type=script&lang=js&"
export * from "./UsersRolesPermissionsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports